import {
    APIProvider,
    AdvancedMarker,
    Map,
    useAdvancedMarkerRef,
} from '@vis.gl/react-google-maps';
import React, { Dispatch, SetStateAction, useState } from 'react';
import { MapHandler } from './mapHandler';
import { PlaceAutocomplete } from './placeAutocomplete';
import { Box } from '@mui/material';

interface MapComponentProps {
    defaultCenter: { lat: number; lng: number };
    defaultZoom: number;
    selectedPoint: { lat: number; lng: number } | null;
    onMapClick: (lat: number, lng: number) => void;
    onPlaceSelect: (place: google.maps.places.PlaceResult | null) => void;
    setValue: Dispatch<SetStateAction<{
        name: string;
        direction: string;
        company?: {
            label: string;
            value: number;
        };
    }>>
    value: {
        name: string;
        direction: string;
        company?: {
            label: string;
            value: number;
        } | undefined;
    },
    title?: string
    compnayId?: number
    role: number;
    companies: {
        id: number;
        value: number;
        label: string;
    }[];
}

const MapActivity = React.memo(({
    defaultCenter,
    defaultZoom,
    selectedPoint,
    onMapClick,
    onPlaceSelect,
    setValue,
    value,
    title,
    compnayId,
    role,
    companies
}: MapComponentProps) => {

    const [markerRef, marker] = useAdvancedMarkerRef();
    const [selectedPlace, setSelectedPlace] = useState<google.maps.places.PlaceResult | null>(null);
    const [error, setError] = useState<{ name: boolean, direction: boolean, company: boolean }>({ name: false, direction: false, company: false });


    const handlePlaceSelect = (place: google.maps.places.PlaceResult | null) => {
        setSelectedPlace(place);
        onPlaceSelect(place); // Notificar al componente padre
        if (place?.geometry?.location) {
            onMapClick(place.geometry.location.lat(), place.geometry.location.lng()); // Actualizar el punto seleccionado
        }
    };

    const API_KEY = process.env.REACT_APP_MAP_APIKEY ?? ''

    return (
        <APIProvider apiKey={API_KEY}>
            <Box sx={{ display: 'flex', gap: 3, width: '100%', height: '100%' }}>
                <PlaceAutocomplete error={error} setError={setError} companies={companies} role={role} compnayId={compnayId} title={title} onPlaceSelect={handlePlaceSelect} value={value} setValue={setValue} />
                <Box sx={{ width: '48%', flexGrow: 1 }}>
                    <Map
                        mapId={'jasdk12q3'}
                        defaultZoom={defaultZoom}
                        defaultCenter={defaultCenter}
                        mapTypeId={'roadmap'}
                        gestureHandling={'greedy'}
                        disableDefaultUI={true}
                        zoomControl={true}
                        fullscreenControl={true}
                        onClick={(e) => {
                            const lat = e.detail.latLng?.lat;
                            const lng = e.detail.latLng?.lng;
                            const placeId = e.detail.placeId;
                            if (lat && lng) {

                                if (placeId) {
                                    const service = new google.maps.places.PlacesService(document.createElement('div'));

                                    service.getDetails(
                                        {
                                            placeId: placeId,
                                            fields: ['name', 'formatted_address', 'geometry']
                                        },
                                        (place, status) => {
                                            if (
                                                status === google.maps.places.PlacesServiceStatus.OK &&
                                                place
                                            ) {
                                                const newName = value.name || place.name || '';
                                                setValue(prev => ({
                                                    ...prev,
                                                    name: newName,
                                                    direction: place.formatted_address ?? ''
                                                }));
                                                setError(prev => ({
                                                    ...prev,
                                                    name: newName.length < 3,
                                                    direction: false
                                                }));
                                            }
                                        }
                                    );
                                }

                                else {
                                    const geocoder = new google.maps.Geocoder();

                                    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                                        if (status === 'OK' && results?.[0]) {
                                            setValue(prev => ({
                                                ...prev,
                                                direction: results[0].formatted_address ?? ''
                                            }))
                                            setError(prev => ({
                                                ...prev,
                                                direction: false
                                            }));
                                        }
                                    });
                                }
                                /* const geocoder = new google.maps.Geocoder()

                                geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                                    if (status === 'OK' && results?.[0]) {
                                        setValue(prev => ({ ...prev, direction: results[0].formatted_address ?? '' }))
                                    } else {
                                        console.error('Geocode was not successful for the following reason:', status)
                                    }
                                }) */
                                onMapClick(lat, lng);
                            }
                        }}
                    >
                        {selectedPoint && (
                            <AdvancedMarker
                                ref={markerRef}
                                position={{ lat: selectedPoint.lat, lng: selectedPoint.lng }}
                            />
                        )}

                        <MapHandler place={selectedPlace} marker={marker} />
                    </Map>
                </Box>
            </Box>
        </APIProvider>
    )
})

export { MapActivity }